export default __webpack_public_path__ + "static/media/LKT_logo.d6d1c386.png";